import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_EVALUATIONS } from '@/api/endpoints';
import { EVALUATION_QUERY_KEY } from '@/api/queryKeys';
import { type EvaluationDetail } from '@/types/overview';
import { unwrapAxiosResponse } from '@/utils/axios';
import { joinPath } from '@/utils/global';

export const useEvaluation = (evaluationId: number | undefined) =>
  useQuery<EvaluationDetail>({
    queryKey: [...EVALUATION_QUERY_KEY, evaluationId],
    queryFn: () =>
      apiClient
        .get<EvaluationDetail>(joinPath(API_EVALUATIONS, String(evaluationId)))
        .then(unwrapAxiosResponse),
    enabled: evaluationId !== undefined,
  });
